import { createRoute, dynamicWrapper } from '@/utils/core';

const routesConfig = (app) => ({
    path: '/energy/energy/:id',
    title: '能效管理',
    component: dynamicWrapper(app, [], () => import('./components'))
});

export default (app) => createRoute(app, routesConfig);
